/**
 * Wrapper of sessionStorage.getItem
 * For case like Failed to read the 'localStorage' property from 'Window'
 */
export function sessionStorageGetItem(key: string): string {
  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

/**
 * Wrapper of sessionStorage.setItem
 */
export function sessionStorageSetItem(key: string, value: string): void {
  try {
    return sessionStorage.setItem(key, value);
  } catch (error) {}
}

/**
 * Wrapper of sessionStorage.removeItem
 */
export function sessionStorageRemoveItem(key: string): void {
  try {
    return sessionStorage.removeItem(key);
  } catch (error) {}
}

